module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('chart', {
    ref: "bar",
    attrs: {
      "options": _vm.bar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-e963a57a!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Hdqty.vue
// module id = 192
// module chunks = 2